import { render } from "./CutsTable.vue?vue&type=template&id=7f174166"
import script from "./CutsTable.vue?vue&type=script&lang=js"
export * from "./CutsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__